export const END_POINT = "http://bg-server-dev.us-east-2.elasticbeanstalk.com"
// export const END_POINT = "http://ec2-18-191-251-80.us-east-2.compute.amazonaws.com:3000"
// export const END_POINT = "http://localhost:3000"

